import { Link } from "react-router-dom";
import "./AboutContentStyles.css";
import about2 from "../assets/about2.png";
import about from "../assets/about.png";
import React from "react";

const AboutContent = () => {
  return (
    <div className="about">
      <div className="left">
        <h1>Quien soy?</h1>
        <p>
          Soy un desarrollador jr. Con ganas de aprender mucho y gran pasión por
          la creación de software!
        </p>
        <Link to="/contact">
          <button className="btn">Contacto</button>
        </Link>
      </div>

      <div className="right">
        <div className="img-container">
          <div className="img-stack top">
            <img src={about2} className="img" alt="true" />
          </div>
          <div className="img-stack bottom">
            <img src={about} className="img" alt="true" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutContent;
